import { FieldConfig, FieldRules, FieldRulesConfig } from '@/types/form'

export interface AddressFormState {
  customer_id: string
  name: string
  phone: string
  address: string
  status: 'active' | 'inactive'
}

export const addressFields: (keyof AddressFormState)[] = [
  'customer_id',
  'name',
  'phone',
  'address',
  'status',
]

interface AddressFieldsConfig extends FieldConfig<{
  customer_id: FieldRules<AddressFormState['customer_id']>
  name: FieldRules<AddressFormState['name']>
  phone: FieldRules<AddressFormState['phone']>
  address: FieldRules<AddressFormState['address']>
  status: FieldRules<AddressFormState['status']>
}> {}

interface AddressFieldsConfigProps extends FieldRulesConfig<AddressFormState> {}

export function addressFieldsConfig(_props: AddressFieldsConfigProps): AddressFieldsConfig {
  return {
    fields: {
      customer_id: {
        rules: {
          required: 'Customer association is required',
        },
      },
      name: {
        rules: {
          required: 'Contact identity is required',
        },
      },
      phone: {
        rules: {
          required: 'Verified phone is required',
        },
      },
      address: {
        rules: {
          required: 'Logistics path is required',
        },
      },
      status: {
        rules: {
          required: 'Lifecycle status is required',
        },
      },
    },
  }
}
